export default __webpack_public_path__ + "protichinta-black.png";